/*
 *
 * Dashboard actions
 *
 */

import {
  GET_LEADER_PROFILE_WATCHER,
  GET_LEADER_PROFILE_SUCCESS,
  GET_DASHBOARD_SUCCESS,
  GET_DASHBOARD_WATCHER,
  GET_TASK_WATCHER,
  GET_TASK_SUCCESS,
  SUBMIT_FEEDBACK_SURVEY_WATCHER,
  DISMISS_FEEDBACK_SURVEY_WATCHER,
} from "./constants"

export function getProfileLeaderWatcher(payload) {
  return {
    type: GET_LEADER_PROFILE_WATCHER,
    payload,
  }
}

export function getProfileLeaderSuccess(payload) {
  return {
    type: GET_LEADER_PROFILE_SUCCESS,
    payload,
  }
}

export function getDashboardWatcher(payload) {
  return {
    type: GET_DASHBOARD_WATCHER,
    payload,
  }
}

export function getDashboardSuccess(payload) {
  return {
    type: GET_DASHBOARD_SUCCESS,
    payload,
  }
}

export function getTaskWatcher(payload) {
  return {
    type: GET_TASK_WATCHER,
    payload,
  }
}

export function getTaskSuccess(payload) {
  return {
    type: GET_TASK_SUCCESS,
    payload,
  }
}

export function submitFeedbackSurvey(payload) {
  return {
    type: SUBMIT_FEEDBACK_SURVEY_WATCHER,
    payload,
  }
}

export function dismissFeedbackSurvey() {
  return {
    type: DISMISS_FEEDBACK_SURVEY_WATCHER,
  }
}
